"use client";

import { useEffect, useEffectEvent, useState } from "react";
import { useRequest } from "./request";

let cachedTenantAddress: string | null = null;
let pendingTenantAddress: Promise<string | null> | null = null;

export function useTenantAddress() {
  const call = useRequest();
  const [tenantAddress, setTenantAddress] = useState<string | null>(
    cachedTenantAddress,
  );

  const loadTenantAddress = useEffectEvent(async () => {
    if (cachedTenantAddress) {
      setTenantAddress(cachedTenantAddress);
      return;
    }

    if (!pendingTenantAddress) {
      pendingTenantAddress = call("getTenantAddress", "GET").then((result) => {
        const address = result.data?.Data ?? result.data?.data;
        return typeof address === "string" && address.trim()
          ? address.trim()
          : null;
      });
    }

    const address = await pendingTenantAddress;
    if (address) {
      cachedTenantAddress = address;
      setTenantAddress(address);
    } else {
      pendingTenantAddress = null;
    }
  });

  useEffect(() => {
    void loadTenantAddress();
  }, []);

  return tenantAddress;
}
